/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
const blackListedExtensions = Object.freeze([
  ".ade",
  ".adp",
  ".app",
  ".arc",
  ".arj",
  ".asp",
  ".bas",
  ".bat",
  ".bz",
  ".bz2",
  ".cab",
  ".chm",
  ".class",
  ".cmd",
  ".com",
  ".command",
  ".cpl",
  ".crt",
  ".csh",
  ".desktop",
  ".dll",
  ".exe",
  ".fxp",
  ".gz",
  ".hex",
  ".hlp",
  ".hqx",
  ".hta",
  ".inf",
  ".ini",
  ".ins",
  ".isp",
  ".its",
  ".job",
  ".js",
  ".jse",
  ".ksh",
  ".lnk",
  ".lzh",
  ".mad",
  ".maf",
  ".mag",
  ".mam",
  ".maq",
  ".mar",
  ".mas",
  ".mat",
  ".mau",
  ".mav",
  ".maw",
  ".mda",
  ".mdb",
  ".mde",
  ".mdt",
  ".mdw",
  ".mdz",
  ".msc",
  ".msi",
  ".msp",
  ".mst",
  ".ocx",
  ".ops",
  ".pcd",
  ".pi",
  ".pif",
  ".prf",
  ".prg",
  ".pst",
  ".rar",
  ".reg",
  ".scf",
  ".scr",
  ".sct",
  ".sea",
  ".shb",
  ".shs",
  ".sit",
  ".tar",
  ".taz",
  ".tgz",
  ".tmp",
  ".url",
  ".vb",
  ".vbe",
  ".vbs",
  ".vsmacros",
  ".vss",
  ".vst",
  ".vsw",
  ".webloc",
  ".ws",
  ".wsc",
  ".wsf",
  ".wsh",
  ".z",
  ".zip",
  ".zlo",
  ".zoo",
  ".jar",
  ".pkg",
  ".tool",
  ".term",
  ".acm",
  ".asa",
  ".aspx",
  ".ax",
  ".ad",
  ".application",
  ".asx",
  ".cer",
  ".cfg",
  ".chi",
  ".clb",
  ".cnt",
  ".cnv",
  ".cpx",
  ".crx",
  ".der",
  ".drv",
  ".fon",
  ".gadget",
  ".grp",
  ".htt",
  ".ime",
  ".jnlp",
  ".local",
  ".manifest",
  ".mmc",
  ".mof",
  ".msh",
  ".msh1",
  ".msh2",
  ".mshxml",
  ".msh1xml",
  ".msh2xml",
  ".mui",
  ".nls",
  ".pl",
  ".perl",
  ".plg",
  ".ps1",
  ".ps2",
  ".ps1xml",
  ".ps2xml",
  ".psc1",
  ".psc2",
  ".py",
  ".pyc",
  ".pyo",
  ".pyd",
  ".rb",
  ".sys",
  ".tlb",
  ".tsp",
  ".xbap",
  ".xnk",
  ".xpi",
  ".air",
  ".appref-ms",
  ".desklink",
  ".glk",
  ".library-ms",
  ".mapimail",
  ".mydocs",
  ".sct",
  ".search-ms",
  ".searchConnector-ms",
  ".vxd",
  ".website",
  ".zfsendtotarget",
  ".mht",
  ".mhtml",
  ".pyw",
  ".swf",
  ".spl",
  ".crx",
  ".xlsm",
  ".xlsb",
  ".xlm",
  ".xltm",
  ".xla",
  ".xlam",
  ".xll",
  ".docm",
  ".dotm",
  ".docb",
  ".pptm",
  ".potm",
  ".ppam",
  ".ppsm",
  ".sldm",
  ".accde",
  ".accdr",
  ".diagcab",
  ".terminal",
  ".diagcfg",
  ".diagpkg",
  ".msu",
  ".printerexport",
  ".psd1",
  ".psdm1",
  ".theme",
  ".webpnp",
  ".pywz",
  ".py3",
  ".pyx",
  ".pxd",
  ".pyi",
  ".pyz",
  ".rpy",
  ".pyde",
  ".pyp",
  ".pyt",
  ".pyzw",
  ".settingcontent-ms",
  ".appcontent-ms",
  ".iso"
]);
export default blackListedExtensions;
